import { ComplexEnumItem } from '../../../utils/complexEnum/ComplexEnumItem'

export class ClasslessFilenameTemplateItem<
  Property extends string,
  ID extends Lowercase<string>
> extends ComplexEnumItem<ID> {
  /**
   * help text associated with the field
   *
   * will be rendered as a tooltip where possible
   */
  help: string
  /**
   * how the property should be displayed to lay users
   */
  name: string
  /**
   * when generating a filename template example, what should be the example
   * value for this template item
   *
   * @default ''
   */
  exampleValue: (() => string) | string
  /**
   * the instance property of the associated {@link classType} that should be used
   * to access the value
   */
  property: Property
  /**
   * whether this template item must appear somewhere in the template
   */
  required?: true
  /**
   * @see {@link ComplexEnumId}
   */
  constructor({
    id,
    help,
    name,
    property,
    exampleValue,
    required,
  }: ClasslessFilenameTemplateItemConstructor<Property, ID>) {
    super(id)
    this.help = help
    this.name = name
    this.property = property
    this.exampleValue = exampleValue ?? ''
    this.required = required
  }

  /**
   * the example value for this template item
   *
   * @see {@link exampleValue}
   */
  get example() {
    return typeof this.exampleValue === 'function'
      ? this.exampleValue()
      : this.exampleValue
  }
}

export type ClasslessFilenameTemplateItemConstructor<
  Property extends string,
  ID extends Lowercase<string>
> = Pick<
  ClasslessFilenameTemplateItem<Property, ID>,
  'id' | 'help' | 'name' | 'property' | 'required'
> &
  Pick<Partial<ClasslessFilenameTemplateItem<Property, ID>>, 'exampleValue'>
